<template lang="pug">
server-data(
  v-model="subordination"
  :key="eventId"
  :method="getSubordination"
  :no-init="!searchSubordination"
  :start-loading-value="searchSubordination"
  :serialize-data="serializeData"
  v-slot="{ loading: isLoading }"
)
  text-loader(v-if="isLoading" :is-init="false")
  server-data(
    v-else
    :value="[]"
    :method="getOrganizers"
    search-field-name="search[name_or_inn]"
    v-slot=`{
      search,
      loading,
      pagination,
      serverData,
      loadMoreItems,
    }`
  )
    dv-autocomplete(
      v-bind="extendedAttrs"
      :loading="loading"
      :items="serverData"
      :hint="pagination ? `Всего: ${pagination.totalCount} организаций` : ''"
      @update:search-input="search"
    )
      template(
        v-for="(_, name) in $scopedSlots"
        v-slot:[name]="data"
      )
        slot(:name="name" v-bind="data")
      template(
        v-for="(_, name) in $slots"
        :slot="name"
      )
        slot(:name="name")

      template(v-slot:append-item)
        div(v-intersect="(val) => onIntersect(val, { loadMoreItems })")
        slot(name="append-item")
      template(v-slot:item="{ item, on, attrs }")
        v-list-item(v-bind="attrs" v-on="on")
          v-list-item-content
            v-list-item-title {{ item.short_name }}
            v-list-item-subtitle.mb-1(v-if="(item.short_name !== item.full_name) && item.full_name") ({{ item.full_name }})
            v-list-item-subtitle Адрес: {{ item.fact_address }}
            v-list-item-subtitle ИНН: {{ item.inn }}
          v-list-item-action-text
            slot(name="item.action" v-bind="{ item }")
</template>

<script>
import DvAutocomplete from '@/packages/ui/components/inputs/DvAutocomplete.vue';

/* eslint-disable indent */

export default {
  components: {
    DvAutocomplete,
  },
  props: {
    eventId: {
      type: [Number, String],
      default: null,
    },
    expand: {
      type: String,
      default: '',
    },
    background: {
      type: String,
      default: 'transparent',
    },
    onlySubordinated: {
      type: Boolean,
      default: false,
    },
    userRegion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      subordination: null,
      serializeData: (resp) => resp.item,
    };
  },
  computed: {
    searchSubordination() {
      const { eventId, onlySubordinated } = this;
      return !!(eventId && onlySubordinated);
    },
    extendedAttrs() {
      const { $attrs, background } = this;
      return {
        'item-value': 'id',
        'no-filter': true,
        'small-chips': true,
        'hide-details': 'auto',
        'persistent-hint': true,
        'item-text': 'short_name',
        label: 'Выберите организатора',
        chips: true,
        clearable: true,
        style: `--background: ${background}`,
        ...$attrs,
      };
    },
    regionId() {
      const { profile } = this.$user || {};
      return profile?.region?.id || null;
    },
  },
  methods: {
    async getOrganizers({ params }) {
      const {
        eventId,
        expand,
        subordination,
        regionId,
        userRegion,
      } = this;
      const payload = {
        params: {
          ...(eventId
            ? {
                'search[main_event_id]': subordination?.main_event_id || eventId,
                expand,
              }
            : []),
          ...(userRegion && regionId
            ? {
                'search[region_id]': regionId,
                expand,
              }
            : []),
          ...params,
        },
      };
      return this.$rApi.user.getOrganizators(payload);
    },
    async getSubordination() {
      const params = {
        'search[organizer_id]': this.$user.data.organizer.id,
        'search[event_id]': this.eventId,
      };

      const { response, error } = await this.$rApi.subordinations.getSubordinations({ params });
      const [item] = response.data.data || [];
      return { item, ...response, ...error };
    },
    onIntersect([{ isIntersecting }], { loadMoreItems }) {
      if (isIntersecting) loadMoreItems();
    },
  },
};
</script>

<style lang="scss" scoped>
$background: var(--background);
::v-deep .v-input__control {
  div[role="combobox"] {
    background: #{var(--background)} !important;
  }
}
</style>
